import React from 'react'
import { Modal, Button,
  Row,
  Col, } from 'react-bootstrap'
import './../assets/scss/style.scss'
import Aux from '../hoc/_Aux'
import Breadcrumb from '../App/layout/AdminLayout/Breadcrumb'
import api from '../utils/Api'
import Colors from '../utils/styles/Colors'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { toast } from 'react-toastify'
import moment from 'moment'
import invApi from '../utils/InventoryApi'
import { subscribeUserToPush } from '../utils/InventoryPushNotification'
import hrApi from '../utils/api/Hr'
import Alert from 'react-bootstrap/Alert';

const MySwal = withReactContent(Swal)

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    forgotPass: false,
    setNewPassword: false,
    resetEmail: '',
    otp: '',
    newPassword: '',
    confirmPassword: '',
    submitting: false,
    redirectTo: '/',
    otpLogin: false,
    otpType: 'email',
    cooldown: 0,
    showModal: false
  }

  interval = null;

  componentDidMount() {
    let search = this.props.location.search
    const { state, hash } = this.props.history.location
    let params = new URLSearchParams(search)
    if (state?.from) {
      this.setState({ redirectTo: state.from.pathname + state.from.search })
    }
    const qs = Object.fromEntries(params)

    const { email, token, sessionExpired } = qs

    if (sessionExpired) {
      this.setState({ showModal: true })
    }

    if (!email || !token) {
      return
    }

    api.request(
      'profile/verify',
      (res, suc) => {
        if (suc) {
          MySwal.fire({
            title: 'ยืนยันอีเมลสำเร็จ !',
            type: 'success',
            text: 'คุณสามารถเข้าสู่ระบบ เพื่อเริ่มใช้งานได้ทันที',
          })
        } else {
          MySwal.fire({
            title: 'ยืนยันอีเมลล้มเหลว !',
            type: 'error',
            text: 'กรุณาลองอีกครั้ง หรือติดต่อทีมงาน',
          })
        }
      },
      { email, token },
      'GET'
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.cooldown > 0 && prevState.cooldown !== this.state.cooldown && !this.interval) {
      this.startCooldown();
    }

    if (this.state.cooldown <= 0 && this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startCooldown = () => {
    this.interval = setInterval(() => {
      this.setState(prevState => ({
        cooldown: prevState.cooldown - 1
      }));
    }, 1000);
  };

  login = () => {
    const { email, password } = this.state

    hrApi.request('login/check', (r, s) => {
      if (!s) return
      this.sendEmailOtp()
      this.setState({ otpLogin: true })
    }, api.form({email, password }), 'POST')
    // api.request(
    //   'login',
    //   async (response, success) => {
    //     if (success) {
    //       const { token, user } = response
    //       localStorage.setItem('api_token', token.token)
    //       localStorage.setItem('user', JSON.stringify(user))
    //       localStorage.setItem('latestFillingPin', moment().toISOString())
    //       await fetchInventoryToken()
    //       await fetchAdminProfile()
    //       await subscribeUserToPush(user.id, user.name, user.email)
    //       this.props.history.replace(this.state.redirectTo)
    //     }
    //   },
    //   api.form({ email, password }),
    //   'POST'
    // )


  } 

  sendEmailOtp = () => { 
    if (this.state.submitting || this.state.cooldown > 0) return
  
    this.setState({ submitting: true })
      hrApi.request(
    'login/request-otp',
    (response, success) => {
      this.setState({ submitting: false, otpSent: success })
      if (success) {
        this.setState({ otpType: 'email', cooldown: 60 }) // Set cooldown to 60 seconds
        // MySwal.fire({
        //   title: '',
        //   type: 'success',
        //   text: response.message,
        // })
      }
    },
    api.form({
      email: this.state.email,
      otpType: 'email'
    }),
    'POST'
  )
  }

  
  render() {
    const fetchInventoryToken = async () => {
      const res = await invApi.get('admins/token')
      if (res.data) {
        localStorage.setItem('inv_token', res.data.token)
      }
    }

    const fetchAdminProfile = async () => {
      const res = await invApi.get('admins/profile')
      if (res.data) {
        localStorage.setItem('inv_user', JSON.stringify(res.data))
      }
    }

    const submitLogin = () => { 
          if (this.state.submitting) {
                  return
                }

              this.setState({ loggingIn: true })
               hrApi.request(
                  'login',
                  async (response, success) => {

                    if (success) {
                      const { token, user } = response
                          localStorage.setItem('api_token_expiry_date', token.expiresAt)
                          localStorage.setItem('api_token', token.token)
                          localStorage.setItem('user', JSON.stringify(user))
                          localStorage.setItem('latestFillingPin', moment().toISOString())
                      try {
                        await fetchInventoryToken()
                        await fetchAdminProfile()
                        await subscribeUserToPush(user.id, user.name, user.email)
                        } catch (e) {
                          console.log('Error fetching inventory token', e)
                        }
                        this.props.history.replace(this.state.redirectTo)
                      
                    } else {
                        this.setState({ loggingIn: false })
                    }
                  },
                  api.form({
                    email: this.state.email,
                    password: this.state.password,
                    pin: this.state.otp,
                    otpType: this.state.otpType
                  }),
                  'POST'
                )
  }

    return (
      <Aux>
        <Breadcrumb />
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="card">
              <div className="row align-items-center text-center">
                <div className="col-md-12">
                  <div className="card-body">
                    <img
                      src={require('../assets/logo-text-primary.png')}
                      alt=""
                      style={{ width: 100 }}
                      className="img-fluid mb-5"
                    />
                    <div className="input-group mb-3">
                      <input
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            this.login()
                          }
                        }}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                        type="email"
                        className="form-control"
                        placeholder="Email address"
                      />
                    </div>
                    <div className="input-group mb-4">
                      <input
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            this.login()
                          }
                        }}
                        type="password"
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                    <div className="text-center mb-3">
                      <a
                        onClick={() => this.setState({ forgotPass: true })}
                        className="text-muted"
                        href="#"
                      >
                        Forgot your password ?
                      </a>
                    </div>
                    {/*<div className="form-group text-left mt-2">
                                            <div className="checkbox checkbox-primary d-inline">
                                                <input type="checkbox" name="checkbox-fill-1" id="checkbox-fill-a1" checked=""/>
                                                <label htmlFor="checkbox-fill-a1" className="cr"> Save credentials</label>
                                            </div>
                                        </div>
                                        */}
                    <button
                      onClick={() => {
                        this.login()
                      }}
                      className="btn btn-block btn-primary mb-4"
                    >
                      Log In
                    </button>
                    {/*<p className="mb-2 text-muted">Forgot password? <NavLink to="/auth/reset-password-1" className="f-w-400">Reset</NavLink></p>
                                        <p className="mb-0 text-muted">Don’t have an account? <NavLink to="/auth/signup-1" className="f-w-400">Signup</NavLink></p>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          animation={true}
          size="md"
          onHide={() => this.setState({ forgotPass: false })}
          centered
          show={this.state.forgotPass}
        >
          <Modal.Body>
            <h4 className="mb-4">Fill your email</h4>
            <div className="my-2">
              <span className="text-muted">We will send otp to your email</span>
            </div>
            <div className="input-group mb-3">
              <input
                onChange={(e) => this.setState({ resetEmail: e.target.value })}
                type="email"
                className="form-control"
                placeholder="Email address"
              />
            </div>
            <button
              onClick={() => {
                if (this.state.submitting) {
                  return
                }

                this.setState({ submitting: true })
                hrApi.request(
                  'login/request-otp',
                  (response, success) => {
                    this.setState({ submitting: false })
                    if (success) {
                      this.setState({ setNewPassword: true, forgotPass: false })
                    }
                  },
                  api.form({ email: this.state.resetEmail, otpType: 'email' }),
                  'POST'
                )
              }}
              className="btn btn-block btn-primary my-4"
            >
              Submit
            </button>
          </Modal.Body>
        </Modal>
        <Modal
          animation={true}
          size="md"
          onHide={() => this.setState({ setNewPassword: false })}
          centered
          show={this.state.setNewPassword}
        >
          <Modal.Body>
            <h5 className="mb-4">Fill otp and set new password</h5>
            <div className="input-group mb-3">
              <input
                onChange={(e) => this.setState({ otp: e.target.value })}
                type="text"
                className="form-control"
                placeholder="OTP"
              />
            </div>
            <div className="input-group mb-3">
              <input
                onChange={(e) => this.setState({ newPassword: e.target.value })}
                type="password"
                className="form-control"
                placeholder="New Password"
              />
            </div>
            <div className="input-group mb-3">
              <input
                onChange={(e) =>
                  this.setState({ confirmPassword: e.target.value })
                }
                type="password"
                className="form-control"
                placeholder="Confirm Password"
              />
            </div>
            <button
              onClick={() => {
                if (this.state.submitting) {
                  return
                }

                if (this.state.newPassword != this.state.confirmPassword) {
                  toast.warn('รหัสผ่านไม่ตรงกัน')
                  return
                }

                this.setState({ submitting: true })
                hrApi.request(
                  'reset-password',
                  (response, success) => {
                    this.setState({ submitting: false })
                    if (success) {
                      this.setState({ setNewPassword: false })
                      MySwal.fire({
                        title: 'รีเซตรหัสผ่านสำเร็จ !',
                        type: 'success',
                        text: 'รหัสผ่านของคุณถูกตั้งใหม่แล้ว',
                      })
                    }
                  },
                  api.form({
                    email: this.state.resetEmail,
                    password: this.state.newPassword,
                    pin: this.state.otp,
                  }),
                  'PATCH'
                )
              }}
              className="btn btn-block btn-primary my-4"
            >
              Submit
            </button>
          </Modal.Body>
        </Modal>
        <Modal
          animation={true}
          size="md"
          onHide={() => this.setState({ otpLogin: false })}
          centered
          show={this.state.otpLogin}
        >
          <Modal.Body>
            <h5 className="mb-4">2FA Login</h5>
            <Alert variant={'info'}>
              <i className="fas fa-info-circle"></i>{" "}ทางเราขอแจ้งให้ทราบว่า ขณะนี้ระบบได้ปรับเปลี่ยนเป็น การเข้าสู่ระบบแบบยืนยันตัวตน 2 ขั้นตอน เพื่อช่วยป้องกันข้อมูลของท่านไม่ให้รั่วไหล แม้ผู้ไม่หวังดีจะได้รหัสผ่านของท่านไปก็ตาม
            </Alert>
            <div className="input-group mb-3">
              <input
                onChange={(e) => this.setState({ otp: e.target.value })}
                type="text"
                className="form-control"
                placeholder="กรุณากรอก OTP ที่ได้รับ"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    submitLogin()
                  }
                }}
              />
            </div>
            <div className="row-edge-center">
              <a href="#" className={!this.state.cooldown?'underline':'text-muted'} onClick={(e) => {
                e.preventDefault()
                this.sendEmailOtp()
              }}>{this.state.submitting?'กำลังส่่ง OTP..':this.state.cooldown > 0 ? `หากไม่ได้รับ OTP กรุณารอ ${this.state.cooldown} วินาทีเพื่อขอรหัส OTP ใหม่` : `ขอรับ OTP เข้าอีเมล`}</a>
            </div>
            <div className="mt-3">
              *หลังเข้าสู่ระบบสำเร็จ Session ของคุณจะหมดอายุวันที่ {moment().add(15, 'days').format('DD/MM/YYYY')}
            </div>
            <button
              onClick={() => {
                submitLogin()
              }}
              className="btn btn-block btn-primary my-4"
            >
              {this.state.loggingIn?`Logging In..`:`Submit`}
            </button>
            { this.state.otpSent && this.state.cooldown <= 0 &&
              <div className="row-center mt-2">
                <a href="#" className="underline" onClick={(e) => {
                  e.preventDefault()
                  this.setState({ submitting: true })
                  hrApi.request(
                    'login/request-otp',
                    (response, success) => {
                      this.setState({ submitting: false })
                      if (success) {
                        this.setState({ otpType: 'mobile', cooldown: 60  })
                        // MySwal.fire({
                        //   title: '',
                        //   type: 'success',
                        //   text: response.message,
                        // })
                      }
                    },
                    api.form({
                      email: this.state.email,
                      otpType: 'mobile'
                    }),
                    'POST'
                  )
                }}>{this.state.submitting?`กำลังส่ง OTP..`:`ไม่ได้รับเมล? ลองขอ OTP เข้าเบอร์โทร`}</a>
              </div>
            }
          </Modal.Body>
        </Modal>
        <Modal
          backdrop={'static'}
          keyboard={false}
          scrollable
          size="md"
          centered
          show={this.state.showModal}
          //onHide={() => this.setState({ showVerifyPin: false })}
        >
            <Modal.Header style={{ backgroundColor: Colors.primaryDark }}>
              <Modal.Title>Session หมดอายุ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-3">
        
                  <Col xs={12} className="mt-2">
                      Session ของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่
                  </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="p-2 row-center">
              <Button variant='primary' type="button" onClick={() => {
                  this.setState({ showModal: false })
              }}>{'ตกลง'}</Button>
            </Modal.Footer>
        </Modal>
      </Aux>
    )
  }
}

export default Login
